import { CUSTOMER_CREATE } from '@/data/url'
import apiClient from '@/services/apiClient'

// The backend endpoint uses get_or_create, so this creates a retail customer
// only when the name is not already present.
const ensureCustomerExists = (customer) =>
    apiClient.post(CUSTOMER_CREATE, {
        customer,
    })

export default {
    ensureCustomerExists,
}
